import { NotificationType } from '@types';
import { convertDateAndTimeToDisplayFormat, formatContent } from '@utils';

import styles from './notificationDetails.module.scss';

interface NotificationListProps {
	notification: NotificationType;
}

export const NotificationDetails = ({ notification }: NotificationListProps) => {
	const { title, content: pushContent, published, data } = notification;
	const content = data ? data.body : pushContent;
	const links = data?.links ?? [];

	const paragraphBlocks = formatContent(content, links);

	return (
		<div className={styles.container} data-testid="notificationDetails">
			<h3 className={styles.title} data-testid="notificationDetailsTitle">
				{title}
			</h3>
			<p className={styles.date}>{convertDateAndTimeToDisplayFormat(published, 'datetimeZone')}</p>
			<div className={styles.border} />
			<div className={styles.content}>
				{paragraphBlocks.map((item, ind) => (
					<p key={ind} className={styles.text}>
						{item.map((block, blockIndex) =>
							block.link ? (
								<a key={blockIndex} href={block.link} target="_blank">
									{block.content}
								</a>
							) : (
								block.content
							),
						)}
					</p>
				))}
			</div>
		</div>
	);
};
